export default "__VITE_ASSET__BTKiPUkM__"